import type { SentryEventFilter } from '../types'

export const filterPermissionIssues: SentryEventFilter = ({ apolloError }) => {
  return Boolean(
    apolloError?.message?.includes('forbidden.insufficient_permissions'),
  )
}
